import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import { formatBrandMoney, formatBrandMoneyCompact, getBrandLocale, getBrandDatePickerLocale } from '../../shared/utils/brandCurrency';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import {ArrowUpDown as MoveIcon, Search, Plus, Edit, Trash2, Package, Calendar, ChevronDown, ChevronUp, Upload, Download, FileSpreadsheet, FileOutput, Filter, Eye, X, XCircle, LayoutGrid, Layers, CheckCircle, Clock, AlertCircle, Check, TrendingUp, TrendingDown, LogIn, LogOut, Warehouse, User, FileText, Info, Calculator, Users, Tag} from 'lucide-react';
import InventaireListPageShell from './components/InventaireListPageShell';
import QawaemErpRowActions from '../../products/saudi/components/QawaemErpRowActions';
import QawaemTableHeaderActionsCell from '../../products/saudi/components/QawaemTableHeaderActionsCell';
import QawaemClickableStatusBadge from '../../products/saudi/components/QawaemClickableStatusBadge';
import { InventaireModalPortal, InventaireViewModalPortal } from './components/inventaireModalPortal';
import FacturationFormModalTabs from '../facturation/components/FacturationFormModalTabs';
import {
  sliceQawaemStats,
  buildInventaireBulkDeleteFilterAction,
  InventaireTableSelectAllHeader,
  InventaireTableRowCheckbox,
  INVENTAIRE_TABLE_ACTIONS_TH_CLASS,
  buildInventaireImportExportProps,
  buildInventaireColumnVisibilityState,
  buildInventaireQawaemColumnDefs,
  isInventaireColumnVisible,
  inventaireTableColSpan,
  nextInventaireEntityRef,
  InventoryConfigNotice,
  useInventaireListSettings,
  sliceInventaireListItems,
  inventaireRecordInDateRange,
  INVENTAIRE_FORM_GRID,
  fetchInventaireWarehouses,
  fetchInventaireSuppliers,
  fetchInventaireClients,
  buildInventaireWarehouseSelectOptions,
  buildInventaireProductSelectOptions,
  buildInventaireSupplierSelectOptions,
  buildInventaireClientSelectOptions,
  mapInventaireWarehouseSelection,
} from './inventaireListPageUtils';
import { useInventoryConfig } from './useInventoryConfig';
import { useArticlesConfig } from '../articles/useArticlesConfig';
import { fetchCatalogProducts } from '../articles/catalogProductOptions';
import { useSettings } from '../../core/contexts/SettingsContext';
import localApiAdapter from '../../core/services/localApiAdapter';
import { exportToCSV, exportToExcel, triggerFileInput, importFromFile } from '../../shared/utils/importExportUtils';
import { generateReportPDF } from '../../shared/utils/reportPdfGenerator';
import { generateReportExcel } from '../../shared/utils/reportExcelGeneratorAdvanced';
import CustomSelect from '../../shared/components/custom/CustomSelect';
import CustomDatePicker from '../../shared/components/custom/CustomDatePicker';
import DatePicker from 'react-datepicker';
import { registerLocale } from 'react-datepicker';
import fr from 'date-fns/locale/fr';
import arLocale from 'date-fns/locale/ar-SA';
import 'react-datepicker/dist/react-datepicker.css';
import '../../shared/styles/GPSTrackingDatePicker.css';
import '../../shared/components/custom/CustomComponents.css';
import { useGlobalTheme } from '../../shared/hooks/useGlobalTheme';
import { useTranslation } from 'react-i18next';
import FacturationViewModeToggle from '../facturation/components/FacturationViewModeToggle';
import TableColumnHeaderFilter from '../../shared/components/table/TableColumnHeaderFilter';
import { useColumnHeaderFilters } from '../../shared/hooks/useColumnHeaderFilters';
import { applyColumnFilters, exactColumnRule, textColumnRule } from '../../shared/utils/columnHeaderFilters';
import { getErpOverviewGridAttrs } from '../../shared/utils/erpOverviewGridAttrs';
import { AppNotificationToast, useAppNotificationToast } from '../../shared/components/AppNotificationToast';
import { notifyBulkDeleted, notifyCreated, notifyDeleted, notifyError, notifyUpdated } from '../../shared/utils/crudNotify';
import { sortRecordsNewestFirst } from '../../shared/utils/listSortUtils';

registerLocale('fr', fr);
registerLocale('ar', arLocale);
registerLocale('ar-SA', arLocale);

const MouvementsStockPage = () => {
  const { t, i18n } = useTranslation();
  const p = (key, opts) => t(`modules.inventaire.pages.mouvementsStockPage.${key}`, opts);
  const { isDashboardLightMode } = useGlobalTheme();
  const dateLocale = getBrandLocale(i18n.language);
  const { settings } = useSettings();
  useArticlesConfig();
  const inventoryConfig = useInventoryConfig();
  const { dateRange, viewMode, setViewMode, itemsPerPage } = useInventaireListSettings(inventoryConfig);
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickOnTypeButton = event.target.closest('[data-movements-type-dropdown-button]');
      const isClickInTypeDropdown = event.target.closest('[data-movements-type-dropdown]');
      if (!isClickOnTypeButton && !isClickInTypeDropdown) setShowTypeDropdown(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const [searchTerm, setSearchTerm] = useState('');
  const [movements, setMovements] = useState([]);
  const [products, setProducts] = useState([]);
  const [warehouses, setWarehouses] = useState([]);
  const [deliveryNotes, setDeliveryNotes] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [suppliers, setSuppliers] = useState([]);
  const [clients, setClients] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [editingRecord, setEditingRecord] = useState(null);
  const [selectedRecords, setSelectedRecords] = useState([]);
  const [showViewModal, setShowViewModal] = useState(false);
  const [viewingRecord, setViewingRecord] = useState(null);
  
  const [movementFormTab, setMovementFormTab] = useState('movementInfo');

  const movementFormTabs = useMemo(() => ([
    { id: 'movementInfo', label: p('section_movement_info'), icon: MoveIcon, iconColor: 'text-green-400' },
    { id: 'quantityInfo', label: p('section_qty_value'), icon: Package, iconColor: 'text-blue-400' },
  ]), [p]);

  
  const [formData, setFormData] = useState({ 
    movement_number: '',
    delivery_note: '', date: new Date().toISOString().split('T')[0],
    movement_type: 'entree', product_id: '', product_name: '', warehouse_id: '', warehouse_name: '',
    quantity: '', unit_price: '', total_value: '', reference: '',
    supplier_customer: '', performed_by: '', notes: ''
  });
  
  const [showAdvancedOptions, setShowAdvancedOptions] = useState(false);
  const [showImportDropdown, setShowImportDropdown] = useState(false);
  const [showExportDropdown, setShowExportDropdown] = useState(false);
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [showTypeDropdown, setShowTypeDropdown] = useState(false);
  const [mainViewMode, setMainViewMode] = useState('all_movements');
  const [quickFilter, setQuickFilter] = useState('all');
  const [isGeneratingPDF, setIsGeneratingPDF] = useState(false);
  const [isGeneratingExcel, setIsGeneratingExcel] = useState(false);
  const [activeDistributionFilter, setActiveDistributionFilter] = useState(null);
  
  const importDropdownRef = useRef(null);
  const exportDropdownRef = useRef(null);
  const typeDropdownRef = useRef(null);

  const { filters: colFilters, setFilter: setColFilter, editingKey, setEditingKey } = useColumnHeaderFilters();
  const { toast: notifyToast, show: showNotify, dismiss: dismissNotify } = useAppNotificationToast();


  useEffect(() => { 
    loadMovements();
    loadProducts();
    loadWarehouses();
    loadDeliveryNotes();
    loadDocuments();
    loadSuppliers();
    loadClients();
  }, []);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (importDropdownRef.current && !importDropdownRef.current.contains(event.target)) setShowImportDropdown(false);
      if (exportDropdownRef.current && !exportDropdownRef.current.contains(event.target)) setShowExportDropdown(false);
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const loadMovements = async () => {
    try {
      const response = await localApiAdapter.get('/inventory/movements');
      setMovements(sortRecordsNewestFirst(response?.data || response || []));
    } catch (error) {
      console.error('Error loading movements:', error);
      setMovements([]);
    }
  };

  const loadProducts = async () => {
    try {
      setProducts(await fetchCatalogProducts());
    } catch (error) {
      console.error('Error loading products:', error);
      setProducts([]);
    }
  };

  const loadWarehouses = async () => {
    try {
      setWarehouses(await fetchInventaireWarehouses());
    } catch (error) {
      console.error('Error loading warehouses:', error);
      setWarehouses([]);
    }
  };

  const loadDeliveryNotes = async () => {
    try {
      // TODO: Load real delivery notes from API
      setDeliveryNotes([]);
    } catch (error) {
      console.error('Error loading delivery notes:', error);
      setDeliveryNotes([]);
    }
  };

  const loadDocuments = async () => {
    try {
      const response = await localApiAdapter.get('/facturation/archives');
      const documentsData = response?.data || response || [];
      setDocuments(documentsData);
    } catch (error) {
      console.error('Error loading documents:', error);
      setDocuments([]);
    }
  };

  const loadSuppliers = async () => {
    try {
      setSuppliers(await fetchInventaireSuppliers());
    } catch (error) {
      console.error('Error loading suppliers:', error);
      setSuppliers([]);
    }
  };

  const loadClients = async () => {
    try {
      setClients(await fetchInventaireClients());
    } catch (error) {
      console.error('Error loading clients:', error);
      setClients([]);
    }
  };

  const generateMovementNumber = useCallback(
    () => nextInventaireEntityRef(settings, 'stockMovement', 'MVT', movements, (m) => m.movement_number),
    [settings, movements],
  );

  const openNewMovementModal = () => {
    if (!inventoryConfig.enableMovements) {
      window.alert(p('notice_movements_disabled', { defaultValue: 'حركات المخزون معطّلة من إعدادات المخزون.' }));
      return;
    }
    setEditingRecord(null);
    setMovementFormTab('movementInfo');
    setFormData({
      movement_number: inventoryConfig.autoGenerateMovementReference !== false ? generateMovementNumber() : '',
      delivery_note: '',
      date: new Date().toISOString().split('T')[0],
      movement_type: 'entree',
      product_id: '',
      product_name: '',
      warehouse_id: '',
      warehouse_name: '',
      quantity: '',
      unit_price: '',
      total_value: '',
      reference: '',
      supplier_customer: '',
      performed_by: '',
      notes: '',
    });
    setShowModal(true);
  };

  const handleDeliveryNoteSelect = (noteNumber) => {
    const note = deliveryNotes.find(n => n.number === noteNumber);
    if (note) {
      // Auto-fill all fields from the selected delivery note
      setFormData(prev => ({
        ...prev,
        delivery_note: note.number,
        movement_date: note.date,
        movement_type: note.movement_type,
        product_name: note.product_name,
        product_code: note.product_code,
        warehouse: note.warehouse,
        quantity: note.quantity?.toString(),
        unit_price: note.unit_price?.toString(),
        total_value: note.total_value?.toString(),
        supplier_customer: note.supplier_customer,
        reference: note.reference,
        performed_by: '',
        notes: p('notes_based_on_delivery_note', { number: note.number })
      }));
    } else {
      // User typed a custom delivery note number - just update that field
      setFormData(prev => ({ ...prev, delivery_note: noteNumber }));
    }
  };

  // Get unique warehouses for distribution
  const uniqueWarehouses = [...new Set(movements.map(m => m.warehouse).filter(Boolean))];
  const warehouseDistribution = uniqueWarehouses.slice(0, 6).map((warehouse, idx) => {
    const colors = [
      'bg-gradient-to-r from-blue-500 to-blue-600',
      'bg-gradient-to-r from-green-500 to-green-600',
      'bg-gradient-to-r from-blue-500 to-blue-600',
      'bg-gradient-to-r from-orange-500 to-orange-600',
      'bg-gradient-to-r from-red-500 to-red-600',
      'bg-gradient-to-r from-yellow-500 to-yellow-600'
    ];
    return {
      name: warehouse,
      count: movements.filter(m => m.warehouse === warehouse).length,
      color: colors[idx % colors.length]
    };
  });

  const stats = {
    total: movements.length,
    entrees: movements.filter(m => m.movement_type === 'entree').length,
    sorties: movements.filter(m => m.movement_type === 'sortie').length,
    valeur_entrees: movements.filter(m => m.movement_type === 'entree').reduce((sum, m) => sum + (parseFloat(m.total_value) || 0), 0),
    valeur_sorties: movements.filter(m => m.movement_type === 'sortie').reduce((sum, m) => sum + (parseFloat(m.total_value) || 0), 0)
  };

  const mainTabs = [
    { id: 'all_movements', name: t('common.general_view'), icon: LayoutGrid },
    { id: 'par_type', name: t('common.by_type'), icon: Layers },
    { id: 'par_entrepot', name: p('tab_by_warehouse'), icon: Warehouse }
  ];

  const quickFilterButtons = [
    { id: 'all', name: t('common.all'), icon: Layers },
    { id: 'entree', name: p('stat_entries'), icon: LogIn },
    { id: 'sortie', name: p('stat_exits'), icon: LogOut }
  ];

  const movementsDistribution = {
    all_movements: {
      title: p('overview_title'),
      data: [
        { filterKey: 'entree', name: p('stat_entries'), count: stats.entrees, color: "bg-gradient-to-r from-green-500 to-green-600" },
        { filterKey: 'sortie', name: p('stat_exits'), count: stats.sorties, color: "bg-gradient-to-r from-red-500 to-red-600" },
        { filterKey: 'valeur_entrees', name: p('stat_entry_value'), count: formatBrandMoneyCompact(stats.valeur_entrees), color: "bg-gradient-to-r from-blue-500 to-blue-600" },
        { filterKey: 'valeur_sorties', name: p('stat_exit_value'), count: formatBrandMoneyCompact(stats.valeur_sorties), color: "bg-gradient-to-r from-orange-500 to-orange-600" }
      ]
    },
    par_type: {
      title: p('distribution_by_type'),
      data: [
        { filterKey: 'entree', name: p('stat_entries'), count: stats.entrees, color: "bg-gradient-to-r from-green-500 to-green-600" },
        { filterKey: 'sortie', name: p('stat_exits'), count: stats.sorties, color: "bg-gradient-to-r from-red-500 to-red-600" }
      ]
    },
    par_entrepot: {
      title: p('distribution_by_warehouse'),
      data: warehouseDistribution.length > 0 ? warehouseDistribution : [
        { name: p('no_warehouse'), count: 0, color: "bg-gradient-to-r from-gray-500 to-gray-600" }
      ]
    }
  };

  const distributionInfo = movementsDistribution[mainViewMode] || movementsDistribution.all_movements;

  const baseFilteredMovements = movements.filter(m => {
    if (!inventaireRecordInDateRange(dateRange, m.date, m.movement_date, m.created_at)) return false;

    if (searchTerm && !m.movement_number?.toLowerCase().includes(searchTerm.toLowerCase()) && !m.product_name?.toLowerCase().includes(searchTerm.toLowerCase()) && !m.warehouse?.toLowerCase().includes(searchTerm.toLowerCase())) return false;
    
    if (mainViewMode === 'all_movements') {
      if (quickFilter === 'entree' && m.movement_type !== 'entree') return false;
      if (quickFilter === 'sortie' && m.movement_type !== 'sortie') return false;
    }
    
    if (activeDistributionFilter) {
      switch(mainViewMode) {
        case 'all_movements':
        case 'par_type':
          if (activeDistributionFilter === 'entree' && m.movement_type !== 'entree') return false;
          if (activeDistributionFilter === 'sortie' && m.movement_type !== 'sortie') return false;
          break;
        case 'par_entrepot':
          if (activeDistributionFilter && m.warehouse !== activeDistributionFilter) return false;
          break;
      }
    }
    
    return true;
  });

  const columnFilterRules = useMemo(() => [
    textColumnRule('movement_number'),
    textColumnRule('movement_date'),
    exactColumnRule('movement_type'),
    textColumnRule('product_name'),
    textColumnRule('warehouse_name'),
    textColumnRule('quantity'),
    textColumnRule('total_value'),
    exactColumnRule('status'),
  ], []);

  const filteredMovements = useMemo(
    () => applyColumnFilters(baseFilteredMovements, colFilters, columnFilterRules),
    [baseFilteredMovements, colFilters, columnFilterRules],
  );
  const visibleMovements = useMemo(
    () => sliceInventaireListItems(filteredMovements, itemsPerPage),
    [filteredMovements, itemsPerPage],
  );

  // Import/Export handlers
  const handleImport = () => {
    triggerFileInput((file) => {
      importFromFile(file, (data) => {
        console.log('Imported data:', data);
        loadMovements();
      });
    });
  };

  const handleExport = () => {
    exportToCSV(filteredMovements, 'mouvements_stock');
  };

  const handleExportPDF = async () => {
    setIsGeneratingPDF(true);
    try {
      await generateReportPDF(
        p('title'),
        filteredMovements,
        ['movement_number', 'movement_date', 'product_name', 'movement_type', 'quantity'],
        'mouvements_stock'
      );
    } catch (error) {
      console.error('Error generating PDF:', error);
    } finally {
      setIsGeneratingPDF(false);
    }
  };

  const handleExportExcel = async () => {
    setIsGeneratingExcel(true);
    try {
      await generateReportExcel(
        p('title'),
        filteredMovements,
        ['movement_number', 'movement_date', 'product_name', 'movement_type', 'quantity'],
        'mouvements_stock'
      );
    } catch (error) {
      console.error('Error generating Excel:', error);
    } finally {
      setIsGeneratingExcel(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Validation: For sortie, warehouse must be selected
      if (formData.movement_type === 'sortie' && !formData.warehouse_id) {
        alert(p('alert_select_warehouse'));
        return;
      }

      // Validation: Product must be selected
      if (!formData.product_id) {
        alert(p('alert_select_product'));
        return;
      }
      
      const movementNumber = (formData.movement_number || '').trim() || generateMovementNumber();

      const submitData = { 
        ...formData,
        movement_number: movementNumber,
        quantity: parseFloat(formData.quantity) || 0,
        unit_price: parseFloat(formData.unit_price) || 0,
        total_value: parseFloat(formData.total_value) || 0,
        reason: formData.supplier_customer, // Map to reason field
        created_by: formData.performed_by  // Map to created_by field
      };
      
      if (editingRecord) {
        await localApiAdapter.put(`/inventory/movements/${editingRecord.id}`, submitData);
        notifyUpdated(showNotify, p('entity_label', { defaultValue: 'حركة المخزون' }));
      } else {
        await localApiAdapter.post('/inventory/movements', submitData);
        notifyCreated(showNotify, p('entity_label', { defaultValue: 'حركة المخزون' }));
      }
    } catch (error) {
      console.error('Error saving:', error);
      notifyError(showNotify, p('alert_save_error', { message: error.message || p('alert_unknown_error') }));
      return;
    } finally {
      resetForm();
      loadMovements();
    }
  };

  const handleEdit = (record) => {
    setEditingRecord(record);
    // Try to find matching product by ID
    const matchingProduct = products.find(p => p.id === record.product_id);
    const matchingWarehouse = warehouses.find(w => w.id === record.warehouse_id);
    setFormData({ 
      movement_number: record.movement_number || '',
      delivery_note: record.document_id || '', date: record.date || new Date().toISOString().split('T')[0],
      movement_type: record.movement_type || 'entree', product_id: record.product_id || '',
      product_name: record.product_name || '', warehouse_id: record.warehouse_id || '', 
      warehouse_name: record.warehouse_name || '', quantity: record.quantity?.toString() || '', 
      unit_price: record.unit_price?.toString() || '', total_value: record.total_value?.toString() || '', 
      reference: record.reference || '', supplier_customer: record.reason || '', 
      performed_by: record.created_by || '', notes: record.notes || ''
    });
    setMovementFormTab('movementInfo');
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm(p('delete_confirm'))) {
      try {
        await localApiAdapter.delete(`/inventory/movements/${id}`);
        notifyDeleted(showNotify, p('entity_label', { defaultValue: 'حركة المخزون' }));
        loadMovements();
      } catch (error) {
        console.error('Error:', error);
        notifyError(showNotify, p('alert_save_error', { message: error.message || p('alert_unknown_error') }));
      }
    }
  };

  const filteredMovementsIds = useMemo(() => filteredMovements.map((r) => r.id), [filteredMovements]);
  const allRowsSelected = filteredMovementsIds.length > 0 && filteredMovementsIds.every((id) => selectedRecords.includes(id));
  const someRowsSelected = selectedRecords.length > 0 && !allRowsSelected;

  const handleSelectAll = () => {
    if (allRowsSelected || someRowsSelected) {
      setSelectedRecords([]);
    } else {
      setSelectedRecords(filteredMovementsIds);
    }
  };
  const handleSelectRecord = (id) => {
    setSelectedRecords((prev) => (prev.includes(id) ? prev.filter((rId) => rId !== id) : [...prev, id]));
  };
  const handleBulkDelete = async () => {
    if (window.confirm(p('delete_bulk_confirm', { count: selectedRecords.length }))) {
      try {
        await Promise.all(selectedRecords.map(id => localApiAdapter.delete(`/inventory/movements/${id}`)));
        notifyBulkDeleted(showNotify, selectedRecords.length, p('entity_label', { defaultValue: 'حركة المخزون' }));
        setSelectedRecords([]);
        loadMovements();
      } catch (error) {
        console.error('Error deleting records:', error);
        notifyError(showNotify, p('alert_save_error', { message: error.message || p('alert_unknown_error') }));
      }
    }
  };

  const resetForm = () => {
    setFormData({ 
      movement_number: '',
      delivery_note: '', date: new Date().toISOString().split('T')[0],
      movement_type: 'entree', product_id: '', product_name: '', warehouse_id: '', warehouse_name: '',
      quantity: '', unit_price: '', total_value: '', reference: '',
      supplier_customer: '', performed_by: '', notes: ''
    });
    setEditingRecord(null);
    setMovementFormTab('movementInfo');
    setShowModal(false);
  };


  const getTypeBadge = (type) => {
    const configs = {
      entree: { label: p('type_entry'), icon: LogIn, style: 'bg-green-500/20 text-green-400 border-green-500/30' },
      sortie: { label: p('type_exit'), icon: LogOut, style: 'bg-red-500/20 text-red-400 border-red-500/30' }
    };
    const config = configs[type] || configs.entree;
    const { label, icon: Icon, style } = config;
    return <span className={`px-3 py-1.5 rounded-full text-xs font-medium flex items-center gap-1.5 border ${style}`}><Icon size={14} />{label}</span>;
  };

  const movementStatusOptions = useMemo(() => [
    { value: 'validated', label: p('status_validated'), icon: CheckCircle, style: 'bg-green-500/20 text-green-400 border-green-500/30' },
    { value: 'pending', label: p('status_pending'), icon: Clock, style: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30' },
    { value: 'cancelled', label: p('status_cancelled'), icon: XCircle, style: 'bg-red-500/20 text-red-400 border-red-500/30' },
  ], [p]);

  const normalizeMovementStatus = (record) => record?.status || 'validated';

  const handleStatusChange = async (recordId, newStatus) => {
    try {
      await localApiAdapter.put(`/inventory/movements/${recordId}`, { status: newStatus });
      setMovements((prev) => prev.map((m) => (m.id === recordId ? { ...m, status: newStatus } : m)));
    } catch (error) {
      console.error('Error updating status:', error);
    }
  };

  const INVENTAIRE_TABLE_COLUMNS = [
    { key: 'movement_number', labelKey: 'col_movement_number' },
    { key: 'movement_date', labelKey: 'col_date' },
    { key: 'movement_type', labelKey: 'col_type' },
    { key: 'product_name', labelKey: 'col_product' },
    { key: 'warehouse_name', labelKey: 'col_warehouse' },
    { key: 'quantity', labelKey: 'col_quantity' },
    { key: 'total_value', labelKey: 'col_value' },
    { key: 'status', labelKey: 'col_status' },
    { key: 'actions', labelKey: 'col_actions', required: true },
  ];

  const [columnVisibility, setColumnVisibility] = useState(() =>
    buildInventaireColumnVisibilityState(INVENTAIRE_TABLE_COLUMNS),
  );
  const qawaemColumnDefs = useMemo(
    () => buildInventaireQawaemColumnDefs(INVENTAIRE_TABLE_COLUMNS, p, columnVisibility),
    [p, columnVisibility],
  );
  const handleToggleColumn = (key) => {
    setColumnVisibility((prev) => ({ ...prev, [key]: !prev[key] }));
  };
  const qawaemVisibleColumnCount = qawaemColumnDefs.filter((c) => c.checked !== false).length;
  const isColVisible = (key) => isInventaireColumnVisible(columnVisibility, key);
  const tableColSpan = inventaireTableColSpan(columnVisibility);

  const inventaireStatEntries = useMemo(() => sliceQawaemStats([
    { key: 'stat_total', label: p('stat_total'), value: stats.total, icon: MoveIcon },
    { key: 'stat_entries', label: p('stat_entries'), value: stats.entrees, icon: TrendingUp },
    { key: 'stat_exits', label: p('stat_exits'), value: stats.sorties, icon: TrendingDown },
    { key: 'stat_entry_value', label: p('stat_entry_value'), value: stats.valeur_entrees, icon: Package },
  ], 4), [stats, p]);


  const importExportProps = useMemo(() => buildInventaireImportExportProps({
    showImportDropdown,
    setShowImportDropdown,
    showExportDropdown,
    setShowExportDropdown,
    importDropdownRef,
    exportDropdownRef,
    importLabel: t('common.import'),
    exportLabel: t('common.export'),
    generatingLabel: p('generating'),
    isGeneratingPDF,
    handlers: {
      onImport: handleImport,
      onExportCSV: handleExport,
      onExportPDF: handleExportPDF,
      onExportExcel: handleExportExcel,
    },
  }), [showImportDropdown, showExportDropdown, isGeneratingPDF, t, p]);

  return (
    <>
    <InventoryConfigNotice
      message={!inventoryConfig.enableMovements ? p('notice_movements_disabled_banner', { defaultValue: 'حركات المخزون معطّلة — فعّلها من إعدادات المخزون ← حركات المخزون.' }) : null}
    />
    <InventaireListPageShell
      title={p('title')}
      subtitle={p('subtitle')}
      icon={MoveIcon}
      statEntries={inventaireStatEntries}
      viewMode={viewMode}
      onViewModeChange={setViewMode}
      searchTerm={searchTerm}
      onSearchChange={setSearchTerm}
      searchPlaceholder={p('search_placeholder')}
      onCreate={openNewMovementModal}
      createLabel={p('new_movement')}
      importExport={importExportProps}
      filterActions={buildInventaireBulkDeleteFilterAction({ count: selectedRecords.length, onDelete: handleBulkDelete, p })}
    >
        {viewMode === 'table' && (
          <div className="glass-table-scroll overflow-x-auto">
            <table className="w-full employees-table data-table">
              <thead className="glass-table-head">
                <tr>
                  <InventaireTableSelectAllHeader allRowsSelected={allRowsSelected} someRowsSelected={someRowsSelected} onSelectAll={handleSelectAll} p={p} />
                  {isColVisible('movement_number') && (

                    <TableColumnHeaderFilter columnKey="movement_number" label={p('col_movement_number')} value={colFilters.movement_number ?? ''} onChange={(v) => setColFilter('movement_number', v)} editingKey={editingKey} onEditingKeyChange={setEditingKey} thClassName="text-white" />
                  )}
                  {isColVisible('movement_date') && (

                    <TableColumnHeaderFilter columnKey="movement_date" label={p('col_date')} value={colFilters.movement_date ?? ''} onChange={(v) => setColFilter('movement_date', v)} editingKey={editingKey} onEditingKeyChange={setEditingKey} thClassName="text-white" />
                  )}
                  {isColVisible('movement_type') && (

                    <TableColumnHeaderFilter columnKey="movement_type" label={p('col_type')} value={colFilters.movement_type ?? ''} onChange={(v) => setColFilter('movement_type', v)} editingKey={editingKey} onEditingKeyChange={setEditingKey} align="center" thClassName="text-white" />
                  )}
                  {isColVisible('product_name') && (

                    <TableColumnHeaderFilter columnKey="product_name" label={p('col_product')} value={colFilters.product_name ?? ''} onChange={(v) => setColFilter('product_name', v)} editingKey={editingKey} onEditingKeyChange={setEditingKey} thClassName="text-white" />
                  )}
                  {isColVisible('warehouse_name') && (

                    <TableColumnHeaderFilter columnKey="warehouse_name" label={p('col_warehouse')} value={colFilters.warehouse_name ?? ''} onChange={(v) => setColFilter('warehouse_name', v)} editingKey={editingKey} onEditingKeyChange={setEditingKey} thClassName="text-white" />
                  )}
                  {isColVisible('quantity') && (

                    <TableColumnHeaderFilter columnKey="quantity" label={p('col_quantity')} value={colFilters.quantity ?? ''} onChange={(v) => setColFilter('quantity', v)} editingKey={editingKey} onEditingKeyChange={setEditingKey} thClassName="text-white" />
                  )}
                  {isColVisible('total_value') && (

                    <TableColumnHeaderFilter columnKey="total_value" label={p('col_value')} value={colFilters.total_value ?? ''} onChange={(v) => setColFilter('total_value', v)} editingKey={editingKey} onEditingKeyChange={setEditingKey} thClassName="text-white" />
                  )}
                  {isColVisible('status') && (

                    <TableColumnHeaderFilter columnKey="status" label={t('common.status')} kind="select" options={movementStatusOptions.map((s) => ({ value: s.value, label: s.label }))} value={colFilters.status ?? ''} onChange={(v) => setColFilter('status', v)} editingKey={editingKey} onEditingKeyChange={setEditingKey} align="center" thClassName="text-white" />
                  )}
                  <QawaemTableHeaderActionsCell
                    label={p('col_actions')}
                    columns={qawaemColumnDefs}
                    onToggle={handleToggleColumn}
                    visibleCount={qawaemVisibleColumnCount}
                    totalCount={qawaemColumnDefs.length}
                    thClassName={INVENTAIRE_TABLE_ACTIONS_TH_CLASS}
                  />
                </tr>
              </thead>
              <tbody className="divide-y divide-white/10 employees-table-body">
                {visibleMovements.length > 0 ? (
                  visibleMovements.map((record, index) => (
                    <tr key={record.id} className={`hover:bg-white/5 transition-colors ${selectedRecords.includes(record.id) ? 'bg-white/10' : ''}`}>
                      <InventaireTableRowCheckbox checked={selectedRecords.includes(record.id)} onChange={() => handleSelectRecord(record.id)} />
                      {isColVisible('movement_number') && (

                        <td className="px-6 py-4">
                        <div className="flex flex-col">
                          <span className="text-white font-semibold">{record.movement_number || '—'}</span>
                          <span className="text-white/50 text-xs mt-0.5">{p('id_label')}: {record.id}</span>
                        </div>
                      </td>

                      )}
                      {isColVisible('movement_date') && (

                        <td className="px-6 py-4">
                        <span className="text-white font-semibold">{new Date(record.date).toLocaleDateString(dateLocale)}</span>
                      </td>

                      )}
                      {isColVisible('movement_type') && (

                        <td className="px-6 py-4 text-center"><div className="flex justify-center">{getTypeBadge(record.movement_type)}</div></td>

                      )}
                      {isColVisible('product_name') && (

                        <td className="px-6 py-4">
                        <div className="flex flex-col">
                          <span className="text-white font-semibold">{record.product_name}</span>
                          <span className="text-white/50 text-xs mt-0.5">{p('code_label')}: {record.product_code || 'N/A'}</span>
                        </div>
                      </td>

                      )}
                      {isColVisible('warehouse_name') && (

                        <td className="px-6 py-4">
                        <span className="text-white font-semibold">{record.warehouse_name || '-'}</span>
                      </td>

                      )}
                      {isColVisible('quantity') && (

                        <td className="px-6 py-4">
                        <div className="flex items-center gap-1">
                          {record.movement_type === 'entree' ? <LogIn size={14} className="text-green-400" /> : <LogOut size={14} className="text-red-400" />}
                          <span className={`font-semibold ${record.movement_type === 'entree' ? 'text-green-400' : 'text-red-400'}`}>
                            {record.movement_type === 'entree' ? '+' : '-'}{record.quantity || 0}
                          </span>
                        </div>
                      </td>

                      )}
                      {isColVisible('total_value') && (

                        <td className="px-6 py-4">
                        <span className="text-white font-semibold">{formatBrandMoney(record.total_value || 0)}</span>
                      </td>

                      )}
                      {isColVisible('status') && (

                        <td className="px-6 py-4 text-center"><div className="flex justify-center"><QawaemClickableStatusBadge status={normalizeMovementStatus(record)} recordId={record.id} options={movementStatusOptions} onChange={handleStatusChange} title={t('common.change_status')} /></div></td>

                      )}
                      <td className="px-6 py-4">
                        <QawaemErpRowActions
                          onView={() => { setViewingRecord(record); setShowViewModal(true); }}
                          onEdit={() => handleEdit(record)}
                          onDelete={() => handleDelete(record.id)}
                          viewTitle={t('common.view')}
                          editTitle={t('common.edit')}
                          deleteTitle={t('common.delete')}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr><td colSpan={tableColSpan} className="text-center py-12 text-white/60"><MoveIcon size={48} className="mx-auto mb-4 text-white/30" /><p className="text-lg">{p('empty')}</p></td></tr>
                )}
              </tbody>
            </table>
          </div>
        )}

        {viewMode === 'cards' && (
          <div className="p-6 grid grid-cols-1 md:grid-cols-3 gap-4">
            {visibleMovements.length > 0 ? (
              visibleMovements.map((record, index) => (
                <motion.div key={record.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: index * 0.05 }} className="bg-white/[0.03] rounded-2xl p-6 border border-white/20 hover:border-white/40 hover:bg-white/[0.05] transition-all h-full min-w-0">
                  <div className="flex items-start justify-between">
                    <div className="flex-1 min-w-0">
                      <div class="flex items-center space-x-4 mb-4">
                        <h3 className="text-xl font-bold text-white flex items-center gap-2">
                          <MoveIcon size={20} className="text-blue-400" />
                          {record.movement_number || '—'}
                        </h3>
                        {getTypeBadge(record.movement_type)}
                        <QawaemClickableStatusBadge status={normalizeMovementStatus(record)} recordId={record.id} options={movementStatusOptions} onChange={handleStatusChange} title={t('common.change_status')} />
                        <span className="text-white/50 text-sm">{new Date(record.date).toLocaleDateString(dateLocale)}</span>
                      </div>
                      <div className={INVENTAIRE_FORM_GRID}>
                        <div>
                          <h5 className="font-medium text-white mb-2">{p('section_product')}</h5>
                          <div className="space-y-1 text-sm text-white/70">
                            <div><span className="font-medium">{p('label_name')}:</span> {record.product_name || '-'}</div>
                            <div><span className="font-medium">{p('label_code')}:</span> {record.product_code || 'N/A'}</div>
                            <div><span className="font-medium">{p('label_warehouse')}:</span> {record.warehouse_name || 'N/A'}</div>
                          </div>
                        </div>
                        <div>
                          <h5 className="font-medium text-white mb-2">{p('section_qty_price')}</h5>
                          <div className="space-y-1 text-sm text-white/70">
                            <div className="flex items-center gap-1">
                              <span className="font-medium">{p('label_qty')}:</span>
                              <span className={`font-bold ${record.movement_type === 'entree' ? 'text-green-400' : 'text-red-400'}`}>
                                {record.movement_type === 'entree' ? '+' : '-'}{record.quantity || 0}
                              </span>
                            </div>
                            <div><span className="font-medium">{p('label_unit_price')}:</span> {formatBrandMoney(record.unit_price || 0)}</div>
                            <div><span className="font-medium">{p('label_total')}:</span> {formatBrandMoney(record.total_value || 0)}</div>
                          </div>
                        </div>
                        <div>
                          <h5 className="font-medium text-white mb-2">{p('section_reference')}</h5>
                          <div className="space-y-1 text-sm text-white/70">
                            <div>{record.reference || p('not_specified')}</div>
                            {record.supplier_customer && <div className="mt-2"><span className="font-medium">{record.movement_type === 'entree' ? p('label_supplier_prefix') : p('label_client_prefix')}</span> {record.supplier_customer}</div>}
                          </div>
                        </div>
                        <div>
                          <h5 className="font-medium text-white mb-2">{p('section_performed_by')}</h5>
                          <div className="space-y-1 text-sm text-white/70">
                            <div>{record.performed_by || 'N/A'}</div>
                            {record.notes && <div className="mt-2 p-2 bg-white/5 rounded"><span className="font-medium text-white/80 text-xs">{p('label_notes')}:</span><p className="text-white/60 text-xs mt-1">{record.notes}</p></div>}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="flex gap-1 ml-4 shrink-0">
                      <QawaemErpRowActions
                        compact
                        size={14}
                      onView={() => { setViewingRecord(record); setShowViewModal(true); }}
                      onEdit={() => handleEdit(record)}
                      onDelete={() => handleDelete(record.id)}
                      viewTitle={t('common.view')}
                      editTitle={t('common.edit')}
                      deleteTitle={t('common.delete')}
                      />
                    </div>
                  </div>
                </motion.div>
              ))
            ) : (
              <div className="col-span-full text-center py-12"><MoveIcon size={48} className="mx-auto mb-4 text-white/30" /><p className="text-white/60 text-lg">{p('empty')}</p></div>
            )}
          </div>
        )}
    </InventaireListPageShell>

      
      {/* Edit/Create Modal */}
      {showModal && (
        <InventaireModalPortal show={showModal} onClose={resetForm} maxWidth="1200px">
            {/* Fixed Header */}
            <div className="flex items-center justify-between p-6 border-b border-white/10 shrink-0">
              <h2 className="text-2xl font-bold text-white">{editingRecord ? p('edit_movement') : p('new_movement')}</h2>
              <div className="flex items-center gap-3">
                <button type="submit" form="movement-form" className="px-6 py-2.5 rounded-xl bg-gradient-to-r from-blue-500 to-blue-700 text-white hover:from-blue-600 hover:to-blue-800 transition-all duration-200 font-semibold flex items-center gap-2 shadow-lg shadow-blue-500/30">
                  <CheckCircle size={18} />
                  {editingRecord ? p('btn_update') : p('btn_create')}
                </button>
                <button onClick={resetForm} className="text-white/70 hover:text-white transition-colors"><X size={24} /></button>
              </div>
            </div>
            
            
            <FacturationFormModalTabs
              tabs={movementFormTabs}
              activeTab={movementFormTab}
              onTabChange={setMovementFormTab}
              isLight={isDashboardLightMode}
              ariaLabel={editingRecord ? p('edit_movement') : p('new_movement')}
            />

            <div className="overflow-y-auto p-6 flex-1 min-h-0">
              <form id="movement-form" onSubmit={handleSubmit}>
              {movementFormTab === 'movementInfo' && (
              <div className={INVENTAIRE_FORM_GRID}>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('label_movement_number', { defaultValue: 'رمز الحركة' })}</label>
                          <input
                            type="text"
                            required
                            value={formData.movement_number || ''}
                            onChange={(e) => setFormData({ ...formData, movement_number: e.target.value })}
                            className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all font-mono"
                            placeholder={p('placeholder_movement_number', { defaultValue: 'MVT-001' })}
                            dir="ltr"
                          />
                        </div>
                        <div className="md:col-span-2">
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right flex items-center gap-2">
                            <FileText size={16} className="text-yellow-400" />
                            {p('label_delivery_note')}
                          </label>
                          <CustomSelect
                            value={formData.delivery_note}
                            onChange={handleDeliveryNoteSelect}
                            options={deliveryNotes.map(note => ({
                              value: note.number,
                              label: `${note.number} - ${note.date} (${note.product_name}) - ${note.quantity} ${p('units_suffix')}`
                            }))}
                            placeholder={p('placeholder_delivery_note')}
                            searchable={true}
                            creatable={true}
                          />
                        </div>
                        
                        <div className={INVENTAIRE_FORM_GRID}>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('label_date')} <span className="qawaem-required-mark">*</span></label>
                          <CustomDatePicker
                            value={formData.date}
                            onChange={(date) => setFormData({ ...formData, date: date })}
                            placeholder={p('placeholder_date')}
                          />
                        </div>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('label_type')} <span className="qawaem-required-mark">*</span></label>
                          <div className="relative" ref={typeDropdownRef}>
                            <button
                              type="button"
                              data-movements-type-dropdown-button="true"
                              onClick={() => setShowTypeDropdown(!showTypeDropdown)}
                              className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all flex items-center justify-between"
                            >
                              <span className="flex items-center gap-2">
                                {formData.movement_type === 'entree' ? <><LogIn size={16} className="text-green-400" /> {p('type_entry')}</> : <><LogOut size={16} className="text-red-400" /> {p('type_exit')}</>}
                              </span>
                              <ChevronDown size={16} className={`transition-transform ${showTypeDropdown ? 'rotate-180' : ''}`} />
                            </button>
                            {showTypeDropdown && ReactDOM.createPortal(
                              <div 
                                data-movements-type-dropdown="true"
                                className="border border-blue-400/60 rounded-2xl shadow-2xl min-w-[200px]" 
                                style={{ position: 'absolute', top: typeDropdownRef.current?.getBoundingClientRect().bottom + 8 + window.scrollY, left: typeDropdownRef.current?.getBoundingClientRect().left + window.scrollX, zIndex: 99999, backgroundImage: 'linear-gradient(to bottom right, rgb(51, 65, 85), rgb(29, 71, 196), rgb(51, 65, 85))', boxShadow: '0 8px 32px rgba(59, 130, 246, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.2)' }}
                              >
                                <div className="p-2">
                                  <button type="button" onClick={() => { setFormData({ ...formData, movement_type: 'entree' }); setShowTypeDropdown(false); }} className="w-full flex items-center gap-2 px-4 py-2.5 hover:bg-blue-500/20 transition-all text-left text-white text-sm font-medium rounded-xl">
                                    <LogIn size={16} className="text-green-400" />{p('type_entry')}
                                  </button>
                                  <button type="button" onClick={() => { setFormData({ ...formData, movement_type: 'sortie' }); setShowTypeDropdown(false); }} className="w-full flex items-center gap-2 px-4 py-2.5 hover:bg-blue-500/20 transition-all text-left text-white text-sm font-medium rounded-xl">
                                    <LogOut size={16} className="text-red-400" />{p('type_exit')}
                                  </button>
                                </div>
                              </div>,
                              document.body
                            )}
                          </div>
                        </div>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">
                            {p('label_external_ref')}
                            <span className="text-white/50 text-xs ml-2">{p('optional')}</span>
                          </label>
                          <CustomSelect
                            value={formData.reference || ''}
                            onChange={(value) => setFormData({ ...formData, reference: value })}
                            options={documents.map(doc => ({
                              value: doc.document_number,
                              label: `${doc.document_number} - ${doc.document_type} - ${doc.client_name || doc.supplier_name || 'N/A'}`
                            }))}
                            placeholder={p('placeholder_external_doc')}
                            searchable={true}
                            creatable={true}
                          />
                        </div>
                        </div>
                        <div className="md:col-span-3">
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">
                            {p('label_product_name_required')}
                            <span className="text-white/50 text-xs ml-2">{p('catalog_hint')}</span>
                          </label>
                          <CustomSelect
                            value={formData.product_name || ''}
                            onChange={(value) => {
                              const selectedProduct = products.find(p => p.id === value);
                              if (selectedProduct) {
                                const productRef = selectedProduct.reference || '';
                                setFormData({ 
                                  ...formData, 
                                  product_id: selectedProduct.id,
                                  product_name: selectedProduct.name,
                                  unit_price: selectedProduct.price?.toString() || ''
                                });
                              } else {
                                setFormData({ 
                                  ...formData, 
                                  product_name: value,
                                  product_id: null
                                });
                              }
                            }}
                            options={products.map(p => ({ 
                              value: p.id, 
                              label: `${p.name}${p.reference ? ` - ${p.reference}` : ''}${p.category ? ` (${p.category})` : ''}` 
                            }))}
                            placeholder={p('placeholder_product')}
                            creatable={true}
                            searchable={true}
                          />
                        </div>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('col_warehouse')} <span className="qawaem-required-mark">*</span></label>
                          <CustomSelect
                            value={formData.warehouse_name || ''}
                            onChange={(warehouseName) => {
                              const selectedWarehouse = warehouses.find(w => w.name === warehouseName);
                              setFormData({ 
                                ...formData, 
                                warehouse_id: selectedWarehouse?.id || null,
                                warehouse_name: warehouseName 
                              });
                            }}
                            options={warehouses.map(w => ({ 
                              value: w.name, 
                              label: `${w.name}${w.city ? ` - ${w.city}` : ''}` 
                            }))}
                            placeholder={p('placeholder_warehouse')}
                            searchable={true}
                          />
                        </div></div>
              )}

              {movementFormTab === 'quantityInfo' && (
              <div className={INVENTAIRE_FORM_GRID}><div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('label_quantity')} <span className="qawaem-required-mark">*</span></label>
                          <div className="relative">
                            <input 
                              type="number" 
                              step="any" 
                              required 
                              value={formData.quantity} 
                              onChange={(e) => {
                                const newQuantity = e.target.value;
                                const totalValue = (parseFloat(newQuantity || 0) * parseFloat(formData.unit_price || 0)).toFixed(2);
                                setFormData({ ...formData, quantity: newQuantity, total_value: totalValue });
                              }} 
                              className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 pr-10 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all number-input-custom" 
                              placeholder="0" 
                            />
                            <div className="absolute right-0 top-0 bottom-0 flex flex-col w-8 border-l border-white/20 rounded-r-xl overflow-hidden">
                              <button type="button" onClick={() => {
                                const newQuantity = Math.max(0, (parseFloat(formData.quantity) || 0) + 1);
                                const totalValue = (newQuantity * parseFloat(formData.unit_price || 0)).toFixed(2);
                                setFormData({ ...formData, quantity: newQuantity.toString(), total_value: totalValue });
                              }} className="flex-1 flex items-center justify-center bg-blue-900/60 hover:bg-blue-600/80 transition-all group">
                                <ChevronUp size={14} className="text-blue-300 group-hover:text-white transition-colors" />
                              </button>
                              <div className="h-px bg-blue-400/30"></div>
                              <button type="button" onClick={() => {
                                const newQuantity = Math.max(0, (parseFloat(formData.quantity) || 0) - 1);
                                const totalValue = (newQuantity * parseFloat(formData.unit_price || 0)).toFixed(2);
                                setFormData({ ...formData, quantity: newQuantity.toString(), total_value: totalValue });
                              }} className="flex-1 flex items-center justify-center bg-blue-900/60 hover:bg-blue-600/80 transition-all group">
                                <ChevronDown size={14} className="text-blue-300 group-hover:text-white transition-colors" />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('label_unit_price_sar')}</label>
                          <div className="relative">
                            <input 
                              type="number" 
                              step="0.01" 
                              value={formData.unit_price} 
                              onChange={(e) => {
                                const newPrice = e.target.value;
                                const totalValue = (parseFloat(newPrice || 0) * parseFloat(formData.quantity || 0)).toFixed(2);
                                setFormData({ ...formData, unit_price: newPrice, total_value: totalValue });
                              }} 
                              className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 pr-10 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all number-input-custom" 
                              placeholder="0.00" 
                            />
                            <div className="absolute right-0 top-0 bottom-0 flex flex-col w-8 border-l border-white/20 rounded-r-xl overflow-hidden">
                              <button type="button" onClick={() => { 
                                const newPrice = Math.max(0, (parseFloat(formData.unit_price) || 0) + 10); 
                                const totalValue = (newPrice * parseFloat(formData.quantity || 0)).toFixed(2);
                                setFormData({ ...formData, unit_price: newPrice.toString(), total_value: totalValue }); 
                              }} className="flex-1 flex items-center justify-center bg-blue-900/60 hover:bg-blue-600/80 transition-all group">
                                <ChevronUp size={14} className="text-blue-300 group-hover:text-white transition-colors" />
                              </button>
                              <div className="h-px bg-blue-400/30"></div>
                              <button type="button" onClick={() => { 
                                const newPrice = Math.max(0, (parseFloat(formData.unit_price) || 0) - 10); 
                                const totalValue = (newPrice * parseFloat(formData.quantity || 0)).toFixed(2);
                                setFormData({ ...formData, unit_price: newPrice.toString(), total_value: totalValue }); 
                              }} className="flex-1 flex items-center justify-center bg-blue-900/60 hover:bg-blue-600/80 transition-all group">
                                <ChevronDown size={14} className="text-blue-300 group-hover:text-white transition-colors" />
                              </button>
                            </div>
                          </div>
                        </div>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('label_total_value_sar')}</label>
                          <input type="number" step="0.01" value={formData.total_value} onChange={(e) => setFormData({ ...formData, total_value: e.target.value })} className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" placeholder="0.00" />
                        </div>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">
                            {formData.movement_type === 'entree' ? p('label_supplier') : p('label_client')}
                          </label>
                          <CustomSelect
                            value={formData.supplier_customer || ''}
                            onChange={(value) => setFormData({ ...formData, supplier_customer: value })}
                            options={formData.movement_type === 'entree' 
                              ? suppliers.map(s => ({ 
                                  value: s.name, 
                                  label: `${s.name}${s.code ? ` - ${s.code}` : ''}` 
                                }))
                              : clients.map(c => ({ 
                                  value: c.name, 
                                  label: `${c.name}${c.code ? ` - ${c.code}` : ''}` 
                                }))
                            }
                            placeholder={formData.movement_type === 'entree' ? p('placeholder_supplier') : p('placeholder_client')}
                            searchable={true}
                            creatable={true}
                          />
                        </div>
                        <div>
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('label_performed_by')}</label>
                          <input type="text" value={formData.performed_by} onChange={(e) => setFormData({ ...formData, performed_by: e.target.value })} className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all" placeholder={p('placeholder_user')} />
                        </div>
                        <div className="md:col-span-3">
                          <label className="block w-full text-white/70 text-sm mb-2 font-medium text-right">{p('label_notes')}</label>
                          <textarea value={formData.notes} onChange={(e) => setFormData({ ...formData, notes: e.target.value })} className="w-full bg-white/10 border border-white/20 rounded-xl px-4 py-2.5 text-white focus:outline-none focus:ring-2 focus:ring-blue-500 transition-all resize-none" placeholder={p('placeholder_notes')} rows="3"></textarea>
                        </div></div>
              )}
              </form>
            </div>
        </InventaireModalPortal>
      )}

      {/* View Modal */}
      {showViewModal && viewingRecord && ReactDOM.createPortal(
        <AnimatePresence>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/20 backdrop-blur-md flex items-center justify-center z-[99999] p-4"
            onClick={() => setShowViewModal(false)}
          >
            <motion.div
              initial={{ scale: 0.95, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.95, opacity: 0 }}
              transition={{ duration: 0.2 }}
              onClick={(e) => e.stopPropagation()}
              className="bg-gradient-to-br from-slate-800 via-blue-750 to-slate-800 backdrop-blur-lg border-2 border-blue-400/60 rounded-2xl p-6 max-h-[90vh] overflow-y-auto"
              style={{ boxShadow: '0 0 40px rgba(59, 130, 246, 0.4), 0 0 80px rgba(59, 130, 246, 0.2)', width: '95%', maxWidth: '1100px' }}
            >
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-white">{p('view_title')}</h2>
                <button onClick={() => setShowViewModal(false)} className="text-white/70 hover:text-white transition-colors">
                  <X size={24} />
                </button>
              </div>

              <div className="space-y-4">
                {/* Informations Générales */}
                <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                  <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
                    <Info size={18} className="text-blue-400" />
                    {p('section_movement_info')}
                  </h3>
                  <div className={INVENTAIRE_FORM_GRID}>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_date')}</p>
                      <p className="text-white font-medium">{viewingRecord.date ? new Date(viewingRecord.date).toLocaleDateString(dateLocale) : p('invalid_date')}</p>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_reference')}</p>
                      <p className="text-white font-medium">{viewingRecord.reference || p('not_specified')}</p>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_performed_by')}</p>
                      <p className="text-white font-medium">{viewingRecord.created_by || p('not_specified')}</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                  <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
                    <Package size={18} className="text-purple-400" />
                    {p('section_product_info')}
                  </h3>
                  <div className={INVENTAIRE_FORM_GRID}>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_name')}</p>
                      <p className="text-white font-medium">{viewingRecord.product_name || p('not_specified')}</p>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_code')}</p>
                      <p className="text-white font-medium">{viewingRecord.product_id || p('not_specified')}</p>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_warehouse')}</p>
                      <p className="text-white font-medium">{viewingRecord.warehouse_name || p('not_specified')}</p>
                    </div>
                  </div>
                </div>

                <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                  <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
                    <Calculator size={18} className="text-green-400" />
                    {p('section_qty_value')}
                  </h3>
                  <div className={INVENTAIRE_FORM_GRID}>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_quantity')}</p>
                      <div className="flex items-center gap-2 mt-1">
                        {viewingRecord.movement_type === 'entree' ? <LogIn className="text-green-400" size={18} /> : <LogOut className="text-red-400" size={18} />}
                        <p className={`text-xl font-bold ${viewingRecord.movement_type === 'entree' ? 'text-green-400' : 'text-red-400'}`}>
                          {viewingRecord.movement_type === 'entree' ? '+' : ''}{viewingRecord.quantity || 0}
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_unit_price')}</p>
                      <p className="text-white font-medium">{formatBrandMoney(viewingRecord.unit_price || 0)}</p>
                    </div>
                    <div>
                      <p className="text-white/60 text-sm mb-1">{p('label_total')}</p>
                      <p className="text-white font-medium text-lg">{formatBrandMoney(viewingRecord.total_value || 0)}</p>
                    </div>
                  </div>
                </div>

                {/* Grid layout for Supplier/Client and Additional Info */}
                {(viewingRecord.reason || viewingRecord.document_id || viewingRecord.notes) && (
                  <div className={INVENTAIRE_FORM_GRID}>
                    {/* Supplier/Client Info */}
                    {viewingRecord.reason && (
                      <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                        <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
                          <Users size={18} className="text-yellow-400" />
                          {viewingRecord.movement_type === 'entree' ? p('label_supplier') : p('label_client')}
                        </h3>
                        <div className="space-y-3">
                          <div>
                            <p className="text-white/60 text-sm mb-1">{p('label_name')}</p>
                            <p className="text-white font-medium">{viewingRecord.reason}</p>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Additional Information */}
                    {(viewingRecord.document_id || viewingRecord.notes) && (
                      <div className="bg-white/5 rounded-xl p-5 border border-white/20">
                        <h3 className="text-white font-semibold mb-4 flex items-center gap-2">
                          <FileText size={18} className="text-orange-400" />
                          {p('section_additional')}
                        </h3>
                        <div className="space-y-3">
                          {viewingRecord.document_id && (
                            <div>
                              <p className="text-white/60 text-sm mb-1">{p('label_external_doc')}</p>
                              <p className="text-white font-medium">{viewingRecord.document_id}</p>
                            </div>
                          )}
                          {viewingRecord.notes && (
                            <div>
                              <p className="text-white/60 text-sm mb-1">{p('label_notes')}</p>
                              <p className="text-white/80 text-sm">{viewingRecord.notes}</p>
                            </div>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </motion.div>
          </motion.div>
        </AnimatePresence>,
        document.body
      )}
      <AppNotificationToast
        visible={notifyToast.visible}
        message={notifyToast.message}
        messageHtml={notifyToast.messageHtml}
        variant={notifyToast.variant}
        status={notifyToast.status}
        showActions={notifyToast.showActions}
        topLabel={notifyToast.topLabel}
        onDismiss={dismissNotify}
        placement="bottom"
      />
    </>
  );
};

export default MouvementsStockPage;


